import store from "../../store";

const client_whirlpool_type = ["Whirlpool", "Haier", "Voltbek", "Clicktech","Crompton","Blubirch"];
const client_reliance_type  = ["Reliance", "Blinkit"];

function is_it_client_whirlpool_type(){
    return client_whirlpool_type.includes(store.state.organization_name)
}
function is_it_client_reliance_type(){
    return client_reliance_type.includes(store.state.organization_name)
}

export { is_it_client_whirlpool_type, is_it_client_reliance_type }